module.exports = __webpack_public_path__ + "static/media/test12_2.91199da7.png";